(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["mbg-generation-products"]) return;
  try {
    
  if (!customElements.get('mbg-generation-forward')) {
    customElements.define('mbg-generation-forward', class extends HTMLElement {
      connectedCallback() {
        if (window.Shopify?.designMode) return;
        const target = new URL(this.dataset.url, window.location.origin);
        if (target.origin !== window.location.origin) return;
        const preview = new URLSearchParams(window.location.search).get('preview_theme_id');
        if (preview && /^\d+$/.test(preview)) target.searchParams.set('preview_theme_id', preview);
        window.location.replace(target.href);
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mbg-guides"]) return;
  try {
    
  if (!customElements.get('mbg-guides')) {
    customElements.define('mbg-guides', class extends HTMLElement {
      connectedCallback() {
        if (this.controller) return;
        this.controller = new AbortController();
        const signal = this.controller.signal;
        const find = key => this.querySelector('[data-guide-key="' + key + '"]');
        const articles = JSON.parse(this.querySelector('[data-guide-articles]').textContent);
var searchInput = find('mmGuideSearch');
  var clearButton = find('mmGuideClear');
  var popularGrid = find('mmPopularGrid');
  var brandGrid = find('mmBrandGrid');
  var allGuides = find('mmAllGuides');
  var emptyBox = find('mmEmpty');
  var resultText = find('mmResultText');
  var popularSection = find('mmPopularSection');
  var brandSection = find('mmBrandSection');

  if (!searchInput || !allGuides) return;

  function normalize(value) {
    return String(value || '')
      .toLowerCase()
      .replace(/[–—]/g, '-')
      .replace(/\s+/g, ' ')
      .trim();
  }

  function escapeHtml(value) {
    return String(value || '').replace(/[&<>"']/g, function (char) {
      return {
        '&': '&amp;',
        '<': '&lt;',
        '>': '&gt;',
        '"': '&quot;',
        "'": '&#039;'
      }[char];
    });
  }

  function getTagValue(tags, key) {
    key = normalize(key);

    for (var i = 0; i < tags.length; i++) {
      var tag = String(tags[i] || '');
      var parts = tag.split(':');

      if (parts.length < 2) continue;

      var tagKey = normalize(parts[0]);
      var tagValue = parts.slice(1).join(':').trim();

      if (tagKey === key) {
        return tagValue;
      }
    }

    return '';
  }

  function getFeatureTags(tags) {
    var features = [];

    tags.forEach(function (tag) {
      var parts = String(tag || '').split(':');

      if (parts.length < 2) return;

      var tagKey = normalize(parts[0]);
      var tagValue = parts.slice(1).join(':').trim();

      if (tagKey === 'feature' && tagValue) {
        features.push(tagValue);
      }
    });

    return features;
  }

  function hasTag(tags, wantedTag) {
    wantedTag = normalize(wantedTag);

    return tags.some(function (tag) {
      return normalize(tag) === wantedTag;
    });
  }

  function cleanBrandName(brand) {
    brand = String(brand || '').trim();

    if (!brand) return 'Ръководство';

    var known = {
      'audi': 'Audi',
      'bmw': 'BMW',
      'chevrolet': 'Chevrolet',
      'fiat': 'Fiat',
      'ford': 'Ford',
      'honda': 'Honda',
      'hyundai': 'Hyundai',
      'kia': 'Kia',
      'mazda': 'Mazda',
      'mercedes-benz': 'Mercedes-Benz',
      'mercedes': 'Mercedes-Benz',
      'mitsubishi': 'Mitsubishi',
      'nissan': 'Nissan',
      'opel': 'Opel',
      'peugeot': 'Peugeot',
      'renault': 'Renault',
      'seat': 'Seat',
      'skoda': 'Skoda',
      'subaru': 'Subaru',
      'suzuki': 'Suzuki',
      'toyota': 'Toyota',
      'volkswagen': 'Volkswagen',
      'vw': 'Volkswagen',
      'vag': 'VAG Group',
      'vag group': 'VAG Group',
      'volvo': 'Volvo'
    };

    return known[normalize(brand)] || brand;
  }

  function cleanProductUrl(url) {
    url = String(url || '').trim();

    if (!url) return '';

    if (url.indexOf('/products/') === 0) return url;
    if (url.indexOf('/collections/') === 0) return url;
    if (url.indexOf('https://') === 0) return url;
    if (url.indexOf('http://') === 0) return url;

    return '';
  }

  function enrichArticle(article) {
    var brand = cleanBrandName(getTagValue(article.tags, 'brand'));
    var headline = getTagValue(article.tags, 'headline');
    var model = getTagValue(article.tags, 'model');
    var years = getTagValue(article.tags, 'years');
    var productUrl = cleanProductUrl(getTagValue(article.tags, 'product'));
    var features = getFeatureTags(article.tags);
    var popular = hasTag(article.tags, 'popular');

    return {
      title: article.title,
      url: article.url,
      excerpt: article.excerpt,
      tags: article.tags,
      brand: brand,
      headline: headline || model || article.title,
      model: model || article.title,
      years: years,
      productUrl: productUrl,
      features: features,
      popular: popular,
      searchText: normalize([
        article.title,
        article.excerpt,
        article.tags.join(' '),
        brand,
        headline,
        model,
        years,
        productUrl,
        features.join(' ')
      ].join(' '))
    };
  }

  var guides = articles.map(enrichArticle);

  function createCard(guide) {
    var featuresHtml = guide.features.map(function (feature) {
      return '<span>' + escapeHtml(feature) + '</span>';
    }).join('');

    var productButton = guide.productUrl
      ? '<a class="mm-guide-btn mm-guide-btn-product button button-secondary" href="' + escapeHtml(guide.productUrl) + '">Виж продукта</a>'
      : '';

    return '' +
      '<article class="mm-model-card mm-guide-item" data-brand="' + escapeHtml(guide.brand) + '" data-search="' + escapeHtml(guide.searchText) + '">' +
        '<div class="mm-model-top">' +
          '<span class="mm-model-brand">' + escapeHtml(guide.brand) + '</span>' +
          '<span class="mm-model-years">' + escapeHtml(guide.years) + '</span>' +
        '</div>' +
        '<h3>' + escapeHtml(guide.headline) + '</h3>' +
        '<p class="mm-model-desc">' + escapeHtml(guide.excerpt) + '</p>' +
        '<div class="mm-model-tags">' + featuresHtml + '</div>' +
        '<div class="mm-model-actions">' +
          '<a class="mm-guide-btn button button-primary" href="' + escapeHtml(guide.url) + '">Ръководство</a>' +
          productButton +
        '</div>' +
      '</article>';
  }

  function getBrands(list) {
    var brands = {};

    list.forEach(function (guide) {
      brands[guide.brand] = true;
    });

    return Object.keys(brands).sort(function (a, b) {
      return a.localeCompare(b);
    });
  }

  function renderBrands() {
    var brands = getBrands(guides);

    brandGrid.innerHTML = brands.map(function (brand) {
      return '' +
        '<button type="button" class="mm-brand-card button button-secondary" data-filter-brand="' + escapeHtml(brand) + '">' +
          '<strong>' + escapeHtml(brand) + '</strong>' +
          '<span>Виж модели</span>' +
        '</button>';
    }).join('');

    brandGrid.querySelectorAll('[data-filter-brand]').forEach(function (button) {
      button.addEventListener('click', function () {
        searchInput.value = button.getAttribute('data-filter-brand');
        filterGuides(searchInput.value);
        searchInput.scrollIntoView({ behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block: 'center' });
      }, { signal: signal });
    });
  }

  function renderPopular() {
    var popular = guides.filter(function (guide) {
      return guide.popular;
    });

    popularGrid.innerHTML = popular.map(createCard).join('');
    popularSection.hidden = popular.length === 0;
  }

  function groupByBrand(list) {
    var groups = {};

    list.forEach(function (guide) {
      if (!groups[guide.brand]) groups[guide.brand] = [];
      groups[guide.brand].push(guide);
    });

    return groups;
  }

  function renderAll(list) {
    var groups = groupByBrand(list);
    var brands = Object.keys(groups).sort(function (a, b) {
      return a.localeCompare(b);
    });

    allGuides.innerHTML = brands.map(function (brand) {
      return '' +
        '<div class="mm-brand-group">' +
          '<div class="mm-brand-group-head">' +
            '<h3>' + escapeHtml(brand) + '</h3>' +
          '</div>' +
          '<div class="mm-model-grid">' +
            groups[brand].map(createCard).join('') +
          '</div>' +
        '</div>';
    }).join('');
  }

  function filterGuides(query) {
    var q = normalize(query);
    var tokens = q.split(' ').filter(Boolean);

    var filtered = guides.filter(function (guide) {
      if (!q) return true;

      return tokens.every(function (token) {
        return guide.searchText.indexOf(token) !== -1;
      });
    });

    renderAll(filtered);

    if (q) {
      if (popularSection) popularSection.hidden = true;
      if (brandSection) brandSection.hidden = true;
      if (resultText) resultText.textContent = 'Намерени: ' + filtered.length + ' ръководства за „' + query + '“';
    } else {
      if (popularSection) popularSection.hidden = !guides.some(function (guide) { return guide.popular; });
      if (brandSection) brandSection.hidden = guides.length === 0;
      if (resultText) resultText.textContent = 'Всички ръководства: ' + filtered.length;
    }

    if (emptyBox) {
      emptyBox.hidden = filtered.length !== 0;
    }
  }

  renderBrands();
  renderPopular();
  filterGuides('');

  searchInput.addEventListener('input', function () {
    filterGuides(searchInput.value);
  }, { signal: signal });

  if (clearButton) {
    clearButton.addEventListener('click', function () {
      searchInput.value = '';
      filterGuides('');
      searchInput.focus();
    }, { signal: signal });
  }

      }
      disconnectedCallback() {
        this.controller?.abort();
        this.controller = null;
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mbg-product-information"] && !Shopify.designMode) return;
  try {
    
(() => {
  if (customElements.get('mbg-product-reviews')) return;

  class MbgProductReviews extends HTMLElement {
    connectedCallback() {
      this.section = this.closest('.mbg-product-information');
      if (!this.section || this.querySelector('.jdgm-review-widget')) return;

      this.onTabsReady = () => queueMicrotask(() => this.moveReviews());
      this.events = ['stationTabsAPIReady', 'stationTabsInstanceReady', 'stationTabsReady'];
      this.events.forEach((event) => document.addEventListener(event, this.onTabsReady));
      this.observer = new MutationObserver(() => this.moveReviews());
      this.observer.observe(this.section, { childList: true, subtree: true });
      this.timer = setTimeout(() => this.observer?.disconnect(), 30000);
      this.moveReviews();
    }

    moveReviews() {
      if (!this.isConnected || this.querySelector('.jdgm-review-widget')) return;

      const widget = this.section.querySelector('.station-tabs-tabpanel .jdgm-review-widget');
      const panel = widget?.closest('.station-tabs-tabpanel');
      const tabs = window.Station?.Apps?.Tabs;
      const tab = panel && tabs?.getTab(panel);
      if (!widget || !tab || typeof tab.remove !== 'function') return;

      this.append(widget);
      this.hidden = false;
      tab.remove();
      this.stopWatching();
    }

    stopWatching() {
      this.observer?.disconnect();
      clearTimeout(this.timer);
      this.events?.forEach((event) => document.removeEventListener(event, this.onTabsReady));
    }

    disconnectedCallback() {
      this.stopWatching();
    }
  }

  customElements.define('mbg-product-reviews', MbgProductReviews);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mbg-vehicle-finder"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('mbg-vehicle-finder')) {
    class MbgVehicleFinder extends HTMLElement {
      connectedCallback() {
        if (this.ready) return;
        this.form = this.querySelector('form');
        this.brand = this.querySelector('[data-mbg-brand]');
        this.model = this.querySelector('[data-mbg-model]');
        this.error = this.querySelector('[data-mbg-error]');
        this.options = this.querySelector('[data-mbg-model-options]')?.content;
        if (!this.form || !this.brand || !this.model || !this.error || !this.options) return;
        this.onBrandChange = () => this.updateModels();
        this.onModelChange = () => this.clearError();
        this.onSubmit = event => this.submit(event);
        this.brand.addEventListener('change', this.onBrandChange);
        this.model.addEventListener('change', this.onModelChange);
        this.form.addEventListener('submit', this.onSubmit);
        this.form.querySelector('[type="submit"]').disabled = false;
        this.ready = true;
        this.updateModels();
      }

      disconnectedCallback() {
        if (!this.ready) return;
        this.brand.removeEventListener('change', this.onBrandChange);
        this.model.removeEventListener('change', this.onModelChange);
        this.form.removeEventListener('submit', this.onSubmit);
        this.ready = false;
      }

      clearError() {
        this.error.textContent = '';
        this.error.hidden = true;
        [this.brand, this.model].forEach(select => {
          select.removeAttribute('aria-invalid');
          select.removeAttribute('aria-describedby');
        });
      }

      updateModels() {
        const previous = this.model.value;
        const options = [...this.options.querySelectorAll('option')].filter(option => option.dataset.brand === this.brand.value);
        this.model.replaceChildren(new Option(this.model.dataset.placeholder, ''));
        options.forEach(option => this.model.append(option.cloneNode(true)));
        this.model.disabled = this.brand.value === '' || options.length === 0;
        if (options.some(option => option.value === previous)) this.model.value = previous;
        this.clearError();
      }

      submit(event) {
        event.preventDefault();
        const allowed = [...this.options.querySelectorAll('option')].find(option => option.dataset.brand === this.brand.value && option.value === this.model.value);
        if (!allowed || this.model.disabled || !this.form.checkValidity()) {
          const invalid = this.brand.value === '' ? this.brand : this.model;
          this.error.textContent = this.dataset.selectionError;
          this.error.hidden = false;
          invalid.setAttribute('aria-invalid', 'true');
          invalid.setAttribute('aria-describedby', this.error.id);
          (invalid.disabled ? this.brand : invalid).focus();
          return;
        }
        const destination = new URL(allowed.value, window.location.origin);
        if (destination.protocol !== 'https:' && destination.protocol !== 'http:') return;
        window.location.assign(allowed.value);
      }
    }
    customElements.define('mbg-vehicle-finder', MbgVehicleFinder);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mbg-vehicle-products"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('mbg-vehicle-products')) {
    class MbgVehicleProducts extends HTMLElement {
      connectedCallback() {
        if (this.dataset.filterValid !== 'true') return;
        const current = new URL(window.location.href);
        if (current.searchParams.get('mbg_open_single') === '1' && this.dataset.designMode !== 'true' && this.dataset.singleProductUrl) {
          try {
            const destination = new URL(this.dataset.singleProductUrl, current.origin);
            if (destination.origin === current.origin && !destination.username && !destination.password && /^\/(?:[a-z]{2}(?:-[a-z]{2})?\/)?products\/[^/]+\/?$/i.test(destination.pathname)) {
              const preview = current.searchParams.get('preview_theme_id');
              if (preview && /^\d{1,20}$/.test(preview)) destination.searchParams.set('preview_theme_id', preview);
              window.location.replace(destination.pathname + destination.search);
              return;
            }
          } catch {}
        }
        const cleanText = (name, limit) => {
          const value = current.searchParams.get(name);
          if (!value || /[\u0000-\u001f\u007f-\u009f]/.test(value)) return '';
          return [...value.trim()].slice(0, limit).join('');
        };
        const title = cleanText('mbg_title', 160);
        const years = cleanText('mbg_years', 80);
        let backPath = '';
        const rawBack = current.searchParams.get('mbg_back');
        if (rawBack && rawBack.length <= 2048 && !/[\u0000-\u001f\u007f-\u009f]/.test(rawBack)) {
          try {
            const suppliedPath = decodeURIComponent(rawBack.trim().split(/[?#]/, 1)[0]);
            const unsafePath = /[\\\u0000-\u001f\u007f-\u009f]/.test(suppliedPath) || /(?:^|\/)\.{1,2}(?:\/|$)/.test(suppliedPath);
            const back = new URL(rawBack.trim(), current.origin);
            const pathMatch = back.pathname.match(/^\/(?:[a-z]{2}(?:-[a-z]{2})?\/)?collections\/([^/]+)\/?$/i);
            const handle = pathMatch ? decodeURIComponent(pathMatch[1]) : '';
            if (!unsafePath && back.origin === current.origin && /^https?:$/.test(back.protocol) && !back.username && !back.password && [...handle].length <= 255 && /^[\p{L}\p{M}\p{N}-]+$/u.test(handle)) {
              backPath = back.pathname;
            }
          } catch {}
        }
        const titleNode = this.querySelector('[data-mbg-title]');
        const yearsNode = this.querySelector('[data-mbg-years]');
        if (title && titleNode) titleNode.textContent = title;
        if (years && yearsNode) {
          yearsNode.textContent = years;
          yearsNode.hidden = false;
        }
        const backNode = this.querySelector('[data-mbg-back]');
        if (backPath && backNode) {
          backNode.href = backPath;
          const label = backNode.querySelector('[data-mbg-back-label]');
          if (label) label.textContent = this.dataset.backLabel;
        }
        const pagination = this.querySelector('.mbg-vehicle-products__pagination');
        if (!pagination) return;
        const pageParam = /^page(?:_[a-z0-9]+)?$/i.test(pagination.dataset.pageParam || '') ? pagination.dataset.pageParam : 'page';
        pagination.querySelectorAll('a[href]').forEach(link => {
          try {
            const source = new URL(link.href, current.origin);
            if (source.origin !== current.origin || source.pathname !== current.pathname) return;
            const destination = new URL(source.pathname, current.origin);
            const page = source.searchParams.get(pageParam);
            if (page && /^[1-9]\d*$/.test(page)) destination.searchParams.set(pageParam, page);
            const sort = current.searchParams.get('sort_by');
            if (sort && /^[a-z-]{1,40}$/.test(sort)) destination.searchParams.set('sort_by', sort);
            destination.searchParams.set('view', 'vehicle-products');
            if (title) destination.searchParams.set('mbg_title', title);
            if (years) destination.searchParams.set('mbg_years', years);
            if (backPath) destination.searchParams.set('mbg_back', backPath);
            const preview = current.searchParams.get('preview_theme_id');
            if (preview && /^\d{1,20}$/.test(preview)) destination.searchParams.set('preview_theme_id', preview);
            link.href = destination.pathname + destination.search;
          } catch {}
        });
      }
    }
    customElements.define('mbg-vehicle-products', MbgVehicleProducts);
  }

  } catch(e) { console.error(e); }
})();
})();
